import { Input } from 'antd';
import styled from 'styled-components';

export const StyledInput = styled(Input)`
    height: 4rem;
    width: 100%;
`;
